import { fromJS, List } from 'immutable';
import { combineActions, createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  passports: List(),
  isLoading: false,
});

// const
export const GET_PASSPORTS = 'passports/GET_PASSPORTS';
export const CREATE_PASSPORT = 'passports/CREATE_PASSPORT';

// action creators
export const getPassports = createAction(
  GET_PASSPORTS,
  api.passports.getPassports,
);
export const createPassport = createAction(
  CREATE_PASSPORT,
  api.passports.createPassport,
);

// reducer
const passports = handleActions(
  {
    [combineActions(`${CREATE_PASSPORT}_REQUEST`, `${GET_PASSPORTS}_REQUEST`)]:
      (state) => state.set('isLoading', true),

    [combineActions(`${CREATE_PASSPORT}_ERROR`, `${GET_PASSPORTS}_ERROR`)]: (
      state,
    ) => state.set('isLoading', false),

    [`${GET_PASSPORTS}_SUCCESS`]: (state, { payload }) => {
      return state
        .set('passports', payload.get('data'))
        .set('isLoading', false);
    },

    [`${CREATE_PASSPORT}_SUCCESS`]: (state, { payload }) =>
      state
        .update('passports', (passports) => passports.push(payload.get('data')))
        .set('isLoading', false),
  },
  initialState,
);

export default passports;
